import React, { FC } from 'react';

import {
	EvBodyMedium,
	EvFlexRow,
	FLEX_ALIGN,
	FLEX_GAP,
	HeadingLevelRange
} from '@evinced-private/ui-common';

import {
	COPY_SELECTOR_BUTTON_DAID,
	SELECTOR_BLOCK_DAID
} from 'data-automation-ids/data-automation-ids';

import { CopyToClipboard } from '../../copy-to-clipboard/CopyToClipboard';
import { TextBlockWithTitle } from '../TextBlockWithTitle';

interface ISelectorTextBlockProps {
	selector?: string;
	headingLevel?: HeadingLevelRange;
}

export const SelectorTextBlock: FC<ISelectorTextBlockProps> = ({ selector, headingLevel }) => {
	const value = (
		<EvFlexRow align={FLEX_ALIGN.CENTER} gap={FLEX_GAP.NONE} dataAutomationId={SELECTOR_BLOCK_DAID}>
			<EvBodyMedium>{selector}</EvBodyMedium>
			<CopyToClipboard
				renderJustIcon
				textToCopy={selector}
				dataAutomationId={COPY_SELECTOR_BUTTON_DAID}
			/>
		</EvFlexRow>
	);

	return <TextBlockWithTitle name="Selector:" value={value} headingLevel={headingLevel} />;
};
